import { Component, ViewContainerRef } from '@angular/core';
import * as $ from 'jquery';

import { GlobalState } from './global.state';
import { BaImageLoaderService, BaThemePreloader, BaThemeSpinner } from './theme/services';
import { BaThemeConfig } from './theme/theme.config';
import { layoutPaths } from './theme/theme.constants';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  styleUrls: ['./app.component.scss'],
  template: `
    <main [class.menu-collapsed]="isMenuCollapsed" baThemeRun>
      <div class="additional-bg"></div>
      <router-outlet></router-outlet>
      <app-auto-logout></app-auto-logout>
      
    </main>
  `
})
export class App {

  isMenuCollapsed: boolean = false;

  constructor(private _state: GlobalState,
              private _imageLoader: BaImageLoaderService,
              private _spinner: BaThemeSpinner,
              private viewContainerRef: ViewContainerRef,
              private themeConfig: BaThemeConfig,
              private router: Router,
              private location: Location) {

    themeConfig.config();

    this._loadImages();

    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });

/*     if (!localStorage.getItem('currentUser') && (this.location.path().split('?')[0] == '/resetPassword' && this.location.path().split('?')[1])) {
        this.router.navigate(['resetPassword']);
    } else if (!localStorage.getItem('currentUser')) {
        this.router.navigate(['login']);
    } else {
        this.router.navigate([decodeURI(this.location.path())]);
    } */
  }

  ngOnInit() {}

  public ngAfterViewInit(): void {
    // hide spinner once all loaders are completed
       //alert("testing 2");
    BaThemePreloader.load().then((values) => {
      this._spinner.hide();
    });
  }

  private _loadImages(): void {
    // register some loaders
    BaThemePreloader.registerLoader(this._imageLoader.load('assets/img/sky-bg.jpg'));
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts